<template>
    <section id="footer" class="pb-1 pt-0 mb-0">
        <div class="footer-top">
            <div class="container">
				<div class="row">
					<div class="col-4 col-lg-2 col-md-3 footer-contact">
						<p>
							<a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=79361&amp;Code=S4VZMPgWpSlvpL9io2nS"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=79361&amp;Code=S4VZMPgWpSlvpL9io2nS" alt="" style="cursor: pointer; max-width: 100px;" id="S4VZMPgWpSlvpL9io2nS"></a>
						</p>
					</div>
					<div class="col-4 col-lg-2 col-md-3 footer-contact">
						<p>
							<img referrerpolicy='origin' id='rgvjjxlznbqesizpfukzfukz' style='cursor:pointer; max-width:100px;' onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=312966&p=xlaorfthuiwkpfvlgvkagvka", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")' alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=312966&p=qftinbpdodrfbsiywlbqwlbq' />
						</p>
					</div>
					<div class="col-4 col-lg-2 col-md-3 footer-contact">
						<p>
							<img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+ " alt="" onclick="window.open('https://ecunion.ir/verify/nicard.ir?token=83191486208bc7a6aafe', 'Popup','toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30')" style="cursor:pointer; max-width:80px;">
						</p>
					</div>

					<div class="col-6 col-lg-3 col-md-6 footer-links">
						<h4>لینک ها</h4>
						<ul>
							<li>
								<b-icon scale="1" icon="chevron-left"></b-icon>
								<router-link to="/content/about-us">درباره ما</router-link>
							</li>
							<li>
								<b-icon scale="1" icon="chevron-left"></b-icon>
								<router-link to="/content/terms-and-conditions">قوانین و مقررات</router-link>
							</li>
							<li>
								<b-icon scale="1" icon="chevron-left"></b-icon>
                                <router-link to="/content/privacy-policy">سیاست حفظ حریم خصوصی</router-link>
							</li>
						</ul>
					</div>
					<div class="col-6 col-lg-3 col-md-6 footer-links">
						<h4>خدمات ما</h4>
						<ul>
							<li>
								<b-icon scale="1" icon="chevron-left"></b-icon>
								<a href="/">نیکارت</a>
							</li>
						</ul>
					</div>
					<!--<div class="col-12 col-lg-4 col-md-6 footer-newsletter">
		<h4>خبرنامه</h4>
		<p>برای دریافت جدیدترین خبرها ایمیل خود را وارد نمایید</p>
		<form action="" method="post">
			<input type="email" name="email" /><input type="submit" value="عضویت" />
		</form>
	</div>-->
				</div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        data()
        {
            return {};
        }
    };
</script>
<style scoped>
    #footer {
        width: 100%;
        float: right;
        color: #444444;
        font-size: 14px;
    }

        #footer .footer-top {
            padding: 60px 0 30px 0;
            background: #fff;
        }

            #footer .footer-top .footer-contact {
                margin-bottom: 30px;
            }

                #footer .footer-top .footer-contact h4 {
                    font-size: 22px;
                    margin: 0 0 30px 0;
                    padding: 2px 0 2px 0;
                    line-height: 1;
                    font-weight: 700;
                }

                #footer .footer-top .footer-contact p {
                    font-size: 14px;
                    line-height: 24px;
                    margin-bottom: 0;
                    color: #777777;
                }

            #footer .footer-top h4 {
                font-size: 16px;
                font-weight: bold;
                color: #444444;
                position: relative;
                padding-bottom: 12px;
            }

            #footer .footer-top .footer-links {
                margin-bottom: 30px;
            }

                #footer .footer-top .footer-links ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }

                    #footer .footer-top .footer-links ul svg {
                        padding-left: 2px;
                        color: #3498db;
                    }

                    #footer .footer-top .footer-links ul li {
                        padding: 10px 0;
                        display: flex;
                        align-items: center;
                    }

                        #footer .footer-top .footer-links ul li:first-child {
                            padding-top: 0;
                        }

                    #footer .footer-top .footer-links ul a {
                        color: #777777;
                        transition: 0.3s;
                        display: inline-block;
                        line-height: 1;
                    }

                        #footer .footer-top .footer-links ul a:hover {
                            text-decoration: none;
                            color: #3498db;
                        }

        #footer .footer-newsletter {
            font-size: 15px;
        }

            #footer .footer-newsletter h4 {
                font-size: 16px;
                font-weight: bold;
                color: #444444;
                position: relative;
                padding-bottom: 12px;
            }

            #footer .footer-newsletter form {
                margin-top: 30px;
                background: #fff;
                padding: 6px 10px;
                position: relative;
                border-radius: 4px;
                text-align: left;
                border: 1px solid #292929;
            }

                #footer .footer-newsletter form input[type="email"] {
                    border: 0;
                    padding: 4px 8px;
                    width: calc(100% - 100px);
                }

                #footer .footer-newsletter form input[type="submit"] {
                    position: absolute;
                    top: 0;
                    right: -2px;
                    bottom: 0;
                    border: 0;
                    background: none;
                    font-size: 16px;
                    padding: 0 20px 2px 20px;
                    background: #292929;
                    color: #fff;
                    transition: 0.3s;
                    border-radius: 0 4px 4px 0;
                }

        #footer .credits {
            padding-top: 5px;
            font-size: 13px;
            color: #444444;
        }

        #footer .social-links a {
            font-size: 18px;
            display: inline-block;
            background: #292929;
            color: #fff;
            line-height: 1;
            padding: 8px 0;
            margin-right: 4px;
            border-radius: 50%;
            text-align: center;
            width: 36px;
            height: 36px;
            transition: 0.3s;
        }

            #footer .social-links a:hover {
                background: #5faee3;
                color: #fff;
                text-decoration: none;
            }
</style>
